import { createContext, useContext } from "react";

type GetAuthToken = () => Promise<string | null>;

const AuthTokenContext = createContext<GetAuthToken>(() =>
	Promise.reject(
		new Error("useAuthTokenGetter must be used within an AuthTokenProvider"),
	),
);

export const AuthTokenProvider = AuthTokenContext.Provider;

export const useAuthTokenGetter = (): GetAuthToken =>
	useContext(AuthTokenContext);

export const authHeaders = (
	token: string | null,
): { Authorization: string } | undefined =>
	token ? { Authorization: token } : undefined;
